import {format, formatDistanceStrict} from "date-fns"

import {phraseReturnReason} from "./returnReasonPhrasing"
import {phraseWaitParty} from "./waitPartyPhrasing"

import type {ActiveCase} from "@indebted/api"

type AttentionStateName = "waiting-with-deadline" | "waiting-open-ended" | "needs-attention"

type CaseAttentionState = {
	Name: AttentionStateName
	Label: string
	Detail: string | null
}

function phraseCaseAttentionState(activeCase: ActiveCase): CaseAttentionState {
	const party = activeCase.WaitParties.find((p) => p.ID === activeCase.WaitParty)
	if (!party) return {Name: "needs-attention", Label: "Needs attention", Detail: phraseReturn(activeCase)}

	return {
		Name: party.HasDeadline ? "waiting-with-deadline" : "waiting-open-ended",
		Label: phraseWaitParty(party).Status,
		Detail: phraseWaitLength(activeCase),
	}
}

// A wait the party owes no dated response to has no deadline to count down to,
// so it reads as how long it has been waiting instead. Every park has always
// recorded the moment it happened, so a case that reaches here waiting carries
// ParkedAt; the field is optional only for a case that was never parked.
function phraseWaitLength(activeCase: ActiveCase): string | null {
	if (activeCase.WaitUntil) return `until ${format(new Date(activeCase.WaitUntil), "d MMM yyyy")}`
	if (activeCase.ParkedAt) return `for ${formatDistanceStrict(new Date(activeCase.ParkedAt), new Date())}`
	return null
}

function phraseReturn(activeCase: ActiveCase): string | null {
	if (!activeCase.ReturnReason || !activeCase.ReturnedAt) return null
	return `Returned ${format(new Date(activeCase.ReturnedAt), "d MMM yyyy")} — ${phraseReturnReason(activeCase.ReturnReason)}`
}

export {phraseCaseAttentionState}
export type {AttentionStateName}
